import Typography from '@elementor/ui/Typography';
import { ResolvedImage } from '@images';
import { StyledResolvedStateContainer } from '@styles/app.styles';
import { __ } from '@utils/i18n';

const NoIssuesLayout = () => {
	return (
		<StyledResolvedStateContainer>
			<ResolvedImage />

			<Typography variant="subtitle1" as="h3" align="center">
				{__('No issues found')}
			</Typography>

			<Typography variant="body2" align="center" color="text.secondary">
				{__('Scan more pages to get full site coverage.')}
			</Typography>
		</StyledResolvedStateContainer>
	);
};

export default NoIssuesLayout;
